import { Routes } from '@angular/router';

import { ConfirmComponent } from './features/user-account/confirm/confirm.component';
import { EmailChangeComponent } from './features/user-account/email-change/email-change.component';
import { HomeComponent } from './features/user-account/home/home.component';
import { ImageComponent } from './features/image/container/image/image.component';
import { LoginComponent } from './features/user-account/login/login.component';
import { PageNotFoundComponent } from './features/shared/page-not-found/page-not-found.component';
import { PasswordChangeComponent } from './features/user-account/password-change/password-change.component';
import { SettingsComponent } from './features/user-account/settings/settings.component';
import { RecoverComponent } from './features/user-account/recover/recover.component';
import { RegisterComponent } from './features/user-account/register/register.component';
import { accountModelResolver } from './features/user-account/resolvers/account-model.resolver';
import { emailChangeModelResolver, passwordChangeModelResolver, settingsModelResolver } from './features/user-account/resolvers/account-page-model.resolver';
import { appGuard } from './auth/guards/app.guard';
import { routePage } from './infrastructure/services/route-service/models/route-page';
import { routeName } from './infrastructure/services/route-service/models/route-name';

export const routes: Routes = [
    { 
        path: 'confirm', 
        component: ConfirmComponent, 
    },
    {
        path: `${routeName.account}/${routeName.emailChange}`,
        component: EmailChangeComponent,
        resolve: { resolver$$: emailChangeModelResolver },
        canActivate: [appGuard],
        data: { animation: 'emailChangePage'}
    },
    {
        path: `${routeName.account}/${routeName.passwordChange}`,
        component: PasswordChangeComponent,
        resolve: { resolver$$: passwordChangeModelResolver },
        canActivate: [appGuard],
        data: { animation: 'passwordChangePage'}
    },
    {
        path: `${routeName.account}/${routeName.settings}`,
        component: SettingsComponent,
        resolve: { resolver$$: settingsModelResolver },
        canActivate: [appGuard],
        data: { animation: 'settingsPage'}
    },
    { 
        path: routePage.adminPanel, 
        loadChildren: () => import('./admin/admin-routes').then(m => m.adminRoutes), 
        data: { animation: 'adminPage'} 
    },
    { 
        path: routeName.domains, 
        loadChildren: () => import('src/app/features/domain/domain-routes').then(m => m.domainRoutes), 
        data: { animation: 'domainPage'} 
    },
    {
        path: routePage.home,
        component: HomeComponent,
        resolve: { resolver$$: accountModelResolver },
        canActivate: [appGuard],
        data: { animation: routePage.home}
    },
    { 
        path: routeName.images, 
        loadChildren: () => import('src/app/features/image/image-routes').then(m => m.imageRoutes), 
        data: { animation: 'imagePage'} 
    },
    { 
        path: routePage.login,
        component: LoginComponent, 
        data: { animation: 'loginPage'} 
    },
    { 
        path: routePage.recover,
        component: RecoverComponent, 
        data: { animation: 'recoverPage'} 
    },
    {
        path: routePage.register,
        component: RegisterComponent,
        data: { animation: 'registerPage'}
    },
    {
        path: '',
        redirectTo: routePage.home,
        pathMatch: 'full'
    },
    { 
        path: '**',
        component: PageNotFoundComponent, 
        data: { animation: 'pageNotFoundPage'} }
];

// @NgModule({
//     imports: [RouterModule.forRoot(routes)],
//     exports: [RouterModule]
// })

// export class AppRoutingModule { }
